<div class="container-sm">
    <h1 class="m-3 display-6 vm-container-header"><i class="bi bi-megaphone me-2"></i> Announcements</h1>

    <div class="pb-5">
        <div class="m-3 p-2 bg-body-light rounded-3 shadow">
            <div class="m-2 pb-1">
                <form autocomplete="off">
                    <div class="mb-3 row align-items-center">
                        <app-table-search [(value)]="this.service.searchTerm" />
                    </div>
                </form>

                <table class="table table-striped table-hover">
                    <caption>
                        <div class="container-fluid">
                            <div class="row justify-content-center align-self-center">
                                <div class="col align-self-center">
                                    {{ this.total$ | async }} Total
                                </div>
                                <div class="col text-end">
                                    <button title="Add announcement" (click)="onAdd()"
                                            class="btn btn-sm btn-outline-primary">
                                        <i class="bi bi-plus-circle me-1"></i> Add
                                    </button>
                                </div>
                            </div>
                        </div>
                    </caption>

                    <thead>
                    <tr>
                        <th scope="col" sortable="message" (sort)="this.onSort($event)">Message</th>
                        <th scope="col" sortable="startDate" (sort)="this.onSort($event)">Start Date</th>
                        <th scope="col" sortable="endDate" (sort)="this.onSort($event)">End Date</th>
                        <th scope="col" class="text-center">Actions</th>
                    </tr>
                    </thead>

                    <tbody class="table-group-divider">
                        @for (element of this.announcements$ | async; track element.id) {
                            <tr>
                                <td class="align-middle" title="{{ element.message }}">{{ element.message }}</td>
                                <td class="align-middle text-nowrap">{{ element.startDate }}</td>
                                <td class="align-middle text-nowrap">{{ element.endDate }}</td>
                                <td class="align-middle text-center">
                                    <div class="btn-group">
                                        <i class="btn btn-sm btn-outline-primary bi bi-pencil"
                                           title="Edit announcement"
                                           (click)="onEdit(element)"></i>
                                        <i class="btn btn-sm btn-outline-primary bi bi-trash"
                                           title="Delete announcement"
                                           (click)="onDelete(element)"></i>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>

                @if (((this.total$ | async) ?? 0) > 0) {
                    <app-table-pager [total]="(this.total$ | async)!" [(page)]="this.service.page" [(pageSize)]="this.service.pageSize" />
                }

                @if (((this.total$ | async) ?? 0) == 0 && !(this.globalService.waitOverlayIsVisible$ | async)) {
                    <div class="card text-center bg-warning-subtle border border-warning rounded p-3 m-5">
                        <div class="card-body">
                            <i class="bi bi-exclamation-triangle-fill me-2"></i>No announcements found.
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>

    <ng-template #announcementModal>
        <div class="modal-header">
            <h5 class="modal-title">
                <i class="bi bi-megaphone me-2"></i>{{ editingId ? 'Edit Announcement' : 'Add Announcement' }}
            </h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="this.closeModal()"></button>
        </div>
        <form [formGroup]="form" (ngSubmit)="onSave()" autocomplete="off">
            <div class="modal-body">
                <div class="form-floating mb-3" [class.is-invalid]="isControlInvalid(form.controls.message)">
                    <textarea id="message" class="form-control" style="height: 8em;" formControlName="message"
                              [class.is-invalid]="isControlInvalid(form.controls.message)"
                              [maxlength]="maxMessageLength"></textarea>
                    <label for="message" class="form-label">Message</label>
                    <div class="invalid-feedback">Required</div>
                </div>
                <div class="row g-3">
                    <div class="col-sm-6">
                        <div class="input-group has-validation">
                            <div class="form-floating" [class.is-invalid]="isControlInvalid(form.controls.startDate)">
                                <input class="form-control" placeholder="yyyy-mm-dd" name="startDate"
                                       formControlName="startDate" id="startDate"
                                       [class.is-invalid]="isControlInvalid(form.controls.startDate)"
                                       ngbDatepicker #startDate="ngbDatepicker"/>
                                <label for="startDate" class="form-label">Start Date</label>
                            </div>
                            <span class="input-group-text bi bi-calendar3" (click)="startDate.toggle()"></span>
                            <div class="invalid-feedback">
                                @if (form.controls.startDate.hasError('required')) {
                                    Required
                                } @else {
                                    Enter a valid date (yyyy-mm-dd)
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="input-group has-validation">
                            <div class="form-floating" [class.is-invalid]="endDateIsInvalid">
                                <input class="form-control" placeholder="yyyy-mm-dd" name="endDate"
                                       formControlName="endDate" id="endDate"
                                       [class.is-invalid]="endDateIsInvalid"
                                       ngbDatepicker #endDate="ngbDatepicker"/>
                                <label for="endDate" class="form-label">End Date</label>
                            </div>
                            <span class="input-group-text bi bi-calendar3" (click)="endDate.toggle()"></span>
                            <div class="invalid-feedback">
                                @if (form.controls.endDate.hasError('required')) {
                                    Required
                                } @else if (form.errors?.['endBeforeStart']) {
                                    End date cannot be before start date
                                } @else {
                                    Enter a valid date (yyyy-mm-dd)
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="callout callout-info small">
                    <i class="bi bi-info-circle me-2 text-info"></i>
                    Dates are inclusive and use US Eastern time.
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary" [disabled]="savingData">
                    @if (!savingData) {
                        <span>Save</span>
                    }
                    @else {
                        <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                    }
                </button>
                <button type="button" class="btn btn-secondary" (click)="this.closeModal()" [disabled]="savingData">Cancel</button>
            </div>
        </form>
    </ng-template>

    <app-modal-confirm #confirmationModal></app-modal-confirm>
</div>
